// extracted by mini-css-extract-plugin
export default {"modalCustom":"modalImageCrop_modalCustom__mmFMX","modalContent":"modalImageCrop_modalContent__IanOU","background":"modalImageCrop_background__BF3Bk"};